/** True when the URL should hide index.html shell chrome (navbar, home search strip, site footer). */
export function isAdminShellRoutePath(pathname: string): boolean {
  const trimmed = (pathname || '').replace(/\/+$/, '');
  if (!trimmed || trimmed === '/') return false;

  if (trimmed === '/mydigitalhome' || trimmed.startsWith('/mydigitalhome/')) {
    return true;
  }

  const segments = trimmed.replace(/^\/+/, '').split('/').filter(Boolean);
  if (!segments.length) return false;

  const first = segments[0].toLowerCase();

  if (
    first === 'subscriptions' ||
    first === 'mysubscription-admin' ||
    first === 'mybusiness-clinic' ||
    first === 'mybusiness-pet' ||
    first === 'mybusiness-hostel' ||
    first === 'mybusiness-hotel' ||
    first === 'mybusiness-food' ||
    first === 'mybusiness-fashion' ||
    first === 'mybusiness-travel' ||
    first === 'mybusiness-realty' ||
    first === 'mybusiness-interior' ||
    first === 'mybusiness-consult' ||
    first === 'mybusiness-mobile' ||
    first === 'mybusiness-profile' ||
    first === 'mybusiness-school' ||
    first === 'mybusiness-capital' ||
    first === 'capital'
  ) {
    return true;
  }
  if (first.startsWith('admin-')) return true;
  if (first === 'admin') return true;

  if (segments.some((seg) => seg.toLowerCase() === 'admin')) return true;

  const vrukshaIdx = segments.findIndex((seg) => seg.toLowerCase() === 'vruksha');
  if (vrukshaIdx >= 0) {
    const section = (segments[vrukshaIdx + 1] || '').toLowerCase();
    if (section === 'invoices' || section === 'invoice') return true;
  }

  if (trimmed.startsWith('/business-items')) return true;

  return false;
}
